<template>
  <div class="unknown">
        <el-form ref="form" label-width="96px" :model="form">
            <el-row>
                <el-col :span="6">
                    <el-form-item label="分公司" prop="branchCompanyId">
                        <el-select v-model="form.branchCompanyId" filterable placeholder="请选择" @change="selectChange">
                            <el-option
                                v-for="item in listBranch"
                                :key="item.id"
                                :label="item.companyFullName"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>    
                </el-col>
                <el-col :span="6">
                <el-form-item label="子公司" prop="companyId">
                    <el-select v-model="form.companyId" filterable placeholder="请选择">
                        <el-option
                            v-for="item in listSon"
                            :key="item.id"
                            :label="item.companyFullName"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                </el-col>
                <el-col :span="6">
                <el-form-item label="开始日期" prop="startTimeString">
                    <el-date-picker
                        @change="startTime"
                        v-model="form.startTimeString"
                        align="right"
                        type="date"
                        placeholder="选择开始日期"
                        format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>
                </el-col>
                <el-col :span="6">
                <el-form-item label="结束日期" prop="endTimeString">
                    <el-date-picker
                        @change="endTime"
                        v-model="form.endTimeString"
                        align="right"
                        type="date"
                        placeholder="选择结束日期"
                        format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>
                </el-col>
            </el-row>

            <el-row type="flex">
            <el-col :span="6">
            <el-form-item label="处理状态" prop="resultStatus">
                <el-select v-model="form.resultStatus" placeholder="请选择">
                <el-option
                    v-for="item in listExamine2"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                ></el-option>
                </el-select>
            </el-form-item>
            </el-col>

            <el-col :span="6">
            <el-form-item label="时间类型筛选" prop="orderType">
            <el-radio-group v-model="form.orderType">
                <el-radio :label="0">全部</el-radio>
                <el-radio :label="1">处理时间</el-radio>
            </el-radio-group>
            </el-form-item>
            </el-col>
            
            <el-col :span="12">
            <el-form-item prop="searchInput" style="flex: 1;">
                <el-input
                    v-model.trim="form.searchString"
                    placeholder="国内单号、未知编号"
                    style="width: 70%;"
                ></el-input>
                <el-button type="primary" @click="searchForm" style="margin-left:10px;">搜索</el-button>
                <el-button type="primary" @click="reset">重置</el-button>
            </el-form-item>
            </el-col>
            </el-row>
            </el-form>

              <el-table :data="tableData" border style="width: 100%;margin-top:20px;" v-loading="loadingTable" :header-cell-style="{ textAlign: 'center' }">
                  <el-table-column prop="unknownNumber" label="未知编号" align="center"></el-table-column>
                  <el-table-column prop="" label="异常信息" align="left" width="300px">
                    <template slot-scope="scope">
                      <el-row type="flex">
                        <el-popover trigger="hover" placement="right">
                          <img :src="scope.row.unknownImages[0]" alt  style="width:500px;height:500px;"/>
                          <div class="scope_img" slot="reference">
                            <img :src="scope.row.unknownImages[0]" alt style="width:50px;height:50px;margin-left:10px;"/>
                          </div>
                        </el-popover>
                        <div style="margin-left:10px;">
                          <p>{{ scope.row.unknownDescription }}</p>
                        </div>
                      </el-row>
                    </template>
                  </el-table-column>
                  <el-table-column prop="internalConveyNumber" label="国内单号" align="center"></el-table-column>
                  <el-table-column label="结果" align="center">
                      <template slot-scope="scope">
                          <span style="color: green;" v-if="scope.row.resultStatus === 2">确认转库存</span>
                          <span style="color: green;" v-if="scope.row.resultStatus === 4">确认退件</span>
                          <span style="color: green;" v-if="scope.row.resultStatus === 6">确认关联采购需求</span>
                          <span style="color: green;" v-if="scope.row.resultStatus === 8">确认重新入库</span>
                      </template>
                  </el-table-column>
                <el-table-column prop="handleDescription" label="处理方案" align="center"></el-table-column>
                <el-table-column label="知会方" align="center">
                    <template slot-scope="scope">
                        {{scope.row.branchCompanyName}}-{{scope.row.subCompanyName}}
                    </template>
                </el-table-column>
                <el-table-column prop="handleTime" label="采购处理时间" sortable align="center"></el-table-column>
                <el-table-column prop="createTime" label="报未知时间" sortable align="center"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="operation(scope.row)">未知件详情</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-dialog title="未知件详情" :visible.sync="details" width="26%" class="details">
                <el-form>
                    <el-form-item label="未知件编号：">
                        <span>{{detailsList.unknownNumber}}</span>
                    </el-form-item>
                    <el-form-item label="国内运单号：">
                        <span>{{detailsList.internalConveyNumber}}</span>
                    </el-form-item>
                    <el-form-item>
                        <el-row class="box">
                        <div v-for="(item,index) in this.imageList" :key="index">
                            <div class="demo-image__preview">
                                <el-image 
                                    style="width:100px;height:100px;margin-left:10px;"
                                    :src="item" 
                                    :preview-src-list="[item]">
                                </el-image>
                            </div>
                        </div>
                        </el-row>
                    </el-form-item>
                    <el-form-item label="未知说明：">
                        <span style="color: red;">{{detailsList.unknownDescription}}</span>
                    </el-form-item>
                    <el-row type="flex" align="middle" style="margin: 10px 0;">
                      <div>处理方案：</div>
                      <div>{{ detailsList.handleDescription }}</div>
                    </el-row>
                </el-form>
            </el-dialog>

            <div class="page">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[50, 100, 200, 400]"
                    :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                ></el-pagination>
            </div>

  </div>
</template>

<script>
import { ajaxPost, Baseurl } from "@/api/api/api";
export default {
    data() {
      return {
        str:"",
        details:false,
        imageList:[],
        detailsList:"",
        form:{
            startTimeString:"",
            endTimeString:"",
            branchCompanyId:"",
            companyId:"",
            searchString:"",
            resultStatus: '',
            orderType:0
        },
        options:[],
        tableData:[],

        currentPage: 1,
        pagesize: 50,
        size: 50,
        total: 0,

        listExamine2: [
          { value: 2, label: '确认转库存' },
          { value: 4, label: '确认退件' },
          { value: 6, label: '确认关联采购需求' },
          { value: 8, label: '确认重新入库' },
        ],
        loadingTable: false,
        listBranch:[],
        listSon:[],

      }
    },
    created(){
        this.str = JSON.parse(localStorage.getItem("role"));
        this.search()
        this.selectList()
        this.getBranchCompanyList()
    },
    methods: {
        search(){
            var obj = {
                companyId:this.str.company_id,
                startTimeString: this.form.startTimeString,
                endTimeString: this.form.endTimeString,
                searchString: this.form.searchString,
                resultStatus: this.form.resultStatus,
                branchCompanyId:this.form.branchCompanyId,
                subCompanyId:this.form.companyId,
                orderType:this.form.orderType,
                page:this.currentPage,
                size:this.size,
                type:1
            };
            this.loadingTable = true
            ajaxPost(Baseurl + "unknownManageController/selectUnknownManageList", obj).then(res => {
                this.loadingTable = false
                this.tableData = res.data.data.list;
                this.total = res.data.data.total;
            });
        },
        getBranchCompanyList() {
            const API = Baseurl + "logisticsController/getAllBranchCompany";
            ajaxPost(API).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.listBranch = data;
                }
            });
        },
        selectChange(val){
            var obj = {
                id:val
            }
            ajaxPost(Baseurl + "logisticsController/getAllSubCompanyById", obj).then(res => {
                this.listSon = res.data.data
                this.form.companyId = ""
            });
        },
        selectList(){
            ajaxPost(Baseurl + "unknownManageController/selectAllSubCompany").then(res => {
                this.options = res.data.data;
                // console.log(res.data)
            });
        },
        searchForm() {
          this.currentPage = 1
          this.search()
        },
        reset(){
            this.currentPage = 1
            this.form.branchCompanyId = ""
            this.form.companyId = ""
            this.form.startTimeString = ""
            this.form.endTimeString = ""
            this.form.searchString = ""
            this.form.resultStatus = ""
            this.form.orderType = 0
            this.listSon = []
            this.search()
        },
        startTime(val) {
            var d = new Date(val);
            var datetime = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + " 00:00:00";
            this.form.startTimeString = datetime;
        },
        endTime(val) {
            var d = new Date(val);
            var datetime = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate() + " 23:59:59";
            this.form.endTimeString = datetime;
        },
        handleSizeChange(val){
            this.size = val;
            this.search()
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.search()
        },
        operation(val){
            this.details = true
            this.detailsList = val
            this.imageList = val.unknownImages
        },
    }
}
</script>

<style lang="scss" scoped>

.unknown{
    margin-top: 30px;
    margin-bottom:50px;
}
.box{
    display: flex;
    justify-content: left;
}
.page {
    position: fixed;
    width: 80%;
    bottom: 0;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
}
</style>
<style lang="scss" scoped>
/deep/{
    .details .el-form-item{
        margin-bottom: 0px!important;
    }
}
</style>